<template>
    <div :class="[
        'float-button-content','animate__animated ',showOrHide ? 'animate__fadeInRight' : 'animate__fadeOutRight'
    ]" ref="floatButtonRef">
        <div class="icon pointer-cursor">
            <el-popover trigger="hover" placement="left" :title="$t('index.floatButton.popoverTitle')" width="200">
                <template #reference>
                    <el-icon class="contact-icon" size="40" :color="'green'">
                        <ChatDotRound />
                    </el-icon>
                </template>

                <div class="contact">
                    <div class="item">
                        <el-image style="width: 30px; height: 30px" :src="email" class="icon"/>
                        <div class="contact-content">
                            <p>lc@lcodin.com</p>
                            <p>lc005@lcodin.com</p>
                            <p>lc003@lcodin.com</p>
                        </div>
                    </div>

                    <div class="item">
                        <el-image style="width: 30px; height: 30px" :src="wechat" class="icon"/>
                        <div class="contact-content">
                            <p>Leo_dydt</p>
                            <p>18279395441</p>
                            <p>19350886484</p>
                        </div>
                    </div>

                    <div class="item">
                        <el-image style="width: 30px; height: 30px" :src="whatsApp" class="icon"/>
                        <div class="contact-content">
                            <p>18666465246</p>
                            <p>008618279395441</p>
                            <p>008619350886484</p>
                        </div>
                    </div>
                </div>
            </el-popover>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Action } from '@/typeDefine/CommonTypes';
import { UtilMethods } from '@/util/UtilMethods';
import {  ref, Ref } from 'vue';
import email from '@/assets/images/email.png'
import wechat from '@/assets/images/wechat.png'
import whatsApp from '@/assets/images/whatsApp.png'

const primaryColor: string = UtilMethods.getDOMStyleFromCSS('--primary-color')

//控制显示
const showOrHide: Ref<boolean> = ref(false)

//隐藏悬浮球
const floatButtonDisplayHandler: Action<[boolean]> = (value: boolean) => {
    showOrHide.value = !value
}

//需要暴露的方法
defineExpose({
    floatButtonDisplayHandler
})
</script>

<style lang="css" scoped>

p {
    margin: 0;
}
.float-button-content {
    position: fixed;
    right: 10px;
    top: 50%;
    z-index: var(--max-z-index);
}

.float-button-content .contact-icon {
    width: 40px;
    height: 40px;
    padding: 8px;
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #eee;
}

.contact .item{
    display: flex;
    margin-bottom: 10px;
}

.contact .item .contact-content p {
    margin-bottom: 10px;
}

.contact .item .icon {
    margin-right: 10px;
    font-size: 20px;
}
</style>